// src/utils/icsHelper.js

export const downloadICS = (event) => {
  // 1. Helper to format dates to ICS format (YYYYMMDDTHHmmSSZ)
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    // Standard ICS requires UTC (Z) format
    return date.toISOString().replace(/-|:|\.\d\d\d/g, "");
  };

  // 2. Handle Start/End times
  const startDate = new Date(event.start);
  const endDate = event.end 
    ? new Date(event.end) 
    : new Date(startDate.getTime() + 60 * 60 * 1000);

  // 3. Robust Location String Construction
  // This ensures we don't end up with "Business Name, " if address is null
  const parts = [
    event.provider?.businessName,
    event.provider?.location?.address || event.provider?.location?.formattedAddress
  ].filter(Boolean); // Removes null/undefined/empty strings
  
  const location = parts.length > 0 ? parts.join(', ') : 'Check event details';

  // 4. Build the ICS content
  // Added 'TRANSP:OPAQUE' so the user shows as "Busy" during the event
  const icsContent = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'CALSCALE:GREGORIAN',
    'PRODID:-//CommunityApp//CommunityEvents//EN',
    'BEGIN:VEVENT',
    `UID:${event._id || Math.random().toString(36).substr(2, 9)}@communityapp.ch`,
    `DTSTAMP:${formatDate(new Date())}`,
    `DTSTART:${formatDate(startDate)}`,
    `DTEND:${formatDate(endDate)}`,
    `SUMMARY:${event.title || 'Local Event'}`,
    `DESCRIPTION:${(event.description || 'Saved from your community dashboard.').replace(/\n/g, '\\n')}`,
    `LOCATION:${location}`,
    'TRANSP:OPAQUE',
    'END:VEVENT',
    'END:VCALENDAR'
  ].join('\r\n');

  // 5. Trigger Download
  const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  
  const link = document.createElement('a');
  link.href = url;
  // Clean filename: No special characters
  const fileName = (event.title || 'event').replace(/[^a-z0-9]/gi, '_').toLowerCase();
  link.setAttribute('download', `${fileName}.ics`);
  
  document.body.appendChild(link);
  link.click();
  
  // Cleanup
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
